export function backgroundHolesColor(skinsHoleBool, ix, highlightWinScore) {
  return () => {
    if (skinsHoleBool || highlightWinScore) {
      return "rgba(10, 132, 255, 0.8)";
    }
    if (ix % 2) {
      return "white";
    }
    return "#ECF3FA";
  };
}
